<template>
    <div>
        <div v-if="listadoAdjEt.length > 0">
        <b-card 
            class="contenedor">
            <div slot="header">
                <strong>Adjunto</strong>
            </div>
            <ListadoAdjuntos></ListadoAdjuntos>
        </b-card>
        </div>
        <div v-else>
            <b-card 
                class="contenedor">
                <div slot="header">
                    <strong><center>Adjuntos</center></strong>
                </div>
                <form method="POST" enctype="multipart/form-data">
                    <b-form-group 
                        label="Idioma:"
                        horizontal
                        breakpoint="md">
                    <b-form-select
                        v-model="selectedAdjuntoEt.idioma"
                        :options="idiomas"
                        :rows="3"
                        :max-rows="6" 
                        :disabled="disabledInputs"
                        class="mb-3" size="sm" />
                    </b-form-group>

                    <b-form-group 
                    label="Tipo:"
                    horizontal
                    breakpoint="md">
                    <b-form-select 
                        v-model="selectedAdjuntoEt.tipo" 
                        :rows="3"
                        :options="[tipos[0],tipos[1],tipos[5]]"
                        :max-rows="6" 
                        :disabled="disabledInputs"
                        class="mb-3" size="sm" />
                    </b-form-group>
                    <b-form-group 
                    label="Fecha:"
                    horizontal
                    breakpoint="md">
                        <b-form-input
                        v-model="selectedAdjuntoEt.fecha"
                        type="date"
                        :disabled="disabledInputs"
                        placeholder="">
                    </b-form-input>
                    </b-form-group>

                    <b-form-group 
                        label="Adjunto:"
                        horizontal
                        breakpoint="md"
                        >
                        <input type="file" :disabled="disabledInputs" @change="getAdjunto">               
                    </b-form-group>
                    <b-form-group
                            horizontal
                            breakpoint="md"
                            label="Observacion:"
                            label-for="inputHorizontal">
                            <b-form-textarea 
                                v-model="selectedAdjuntoEt.observacion"
                                placeholder="Observacion del adjunto..."
                                :disabled="disabledInputs"
                                :rows="3"
                                :max-rows="6">
                            </b-form-textarea>
                    </b-form-group>                
                    <b-button size="sm" v-if="selectedProductEt.finalizado == 0" variant="primary" style="display:block;margin:auto;" @click="guardar()"><i class="fa fa-floppy-o"></i> Guardar</b-button>
                </form>
            </b-card>
        </div>        
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import ListadoAdjuntos from './ListadoAdjuntos.vue';

export default {
    name:'Adjuntos',
    data: function(){
        return{
            file: ""
        };
    },
    components:{
        ListadoAdjuntos
    },
    computed:{
        disabledInputs() {
            return this.selectedProductEt.finalizado == 0 ? false : true
        },  
        ...mapState('adjuntos', [
            'tipos',
            'idiomas'
        ]),
        ...mapState('productos_et',[
            'selectedProductEt'
        ]),  
        ...mapState('adjuntos_et', [
            'selectedAdjuntoEt',
            'estados_fds',
            'cumple_decreto',
            'fecha',
            'adjunto',
            'Actualiza',
            'listadoAdjEt'
        ])
    },
    methods: {
        ...mapActions('adjuntos_et', [
            'guardaAdjunto'
        ]),        
        getAdjunto(){
            //Asignamos la imagen a  nuestra data
            this.file = event.target.files[0];
        },
        guardar(){
            const formData = new FormData();
            formData.append("avatar", this.file);
            this.guardaAdjunto(formData);
        }
    },

}
</script>